import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { AppLoaderPage } from '@/pages/AppLoaderPage';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Landing page of a super admin mock login opened from the admin portal.
 * The token (and, for "Open as HR", the company to open) arrive in the URL
 * fragment, which never reaches a server log; the older query string form
 * is still accepted. The URL is replaced right away so the token does not
 * stay in the address bar or the history.
 */
export function MockLoginPage() {
  const [searchParams] = useSearchParams();
  const { setMockLoginToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const token = fragment.get('token') ?? searchParams.get('token');
    const companyId =
      fragment.get('companyId') ?? searchParams.get('companyId');
    if (token) {
      setMockLoginToken(
        token,
        companyId && UUID.test(companyId) ? companyId : null
      );
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, []);

  return <AppLoaderPage />;
}
